<template>
  <div>   
    <div class="container"> 
      <b-navbar>
        <template #start>
            <b-navbar-item v-bind:href="apiUrl">
              <span class="content is-size-2 has-text-weight-bold">
                <font-awesome-icon icon="film" /> Rollideo
              </span>
            </b-navbar-item>
        </template>
        <template #end>
            <b-navbar-dropdown label="API">
                <b-navbar-item v-bind:href="apiUrl + '/apistep'">
                    <strong>API Quick Start</strong>
                </b-navbar-item>
                <b-navbar-item v-bind:href="apiUrl + '/apiguide'">
                    <strong>API documentation</strong>
                </b-navbar-item>
            </b-navbar-dropdown>

            <b-navbar-item href="https://rollideo.com/blog/mainpage">
                <strong>Blog</strong>
            </b-navbar-item>

             <b-navbar-item v-bind:href="apiUrl + '/contact'">
                <strong>Contact</strong>
            </b-navbar-item>

            <b-navbar-item v-bind:href="apiUrl + '/subscribe'">       
                <strong>Sign up</strong>
            </b-navbar-item>

            <b-navbar-item v-bind:href="apiUrl + '/login'">
                <strong>Log in</strong>
            </b-navbar-item>
        </template>
      </b-navbar> 
      <div class="box has-background-grey-lighter" >
        <h1 class="title is-3 has-text-info">Rollideo: create videos with a single click.</h1>
        <div class="pre-formatted">

THE GOOD, THE BAD AND THE UGLY OF VIDEO CREATION

You start to make video editing, and you have fun learning the ropes. 

You think about the entertaining movies that you like to watch, and now you are part of a creative process.

But after a while video editing can become tedious.

And not only video creation can be tedious and time-consuming, it’s expensive too. For example hiring voice-over professionals is costly, especially the best ones, and these professionals are busy and not easy to book.

If you are on a budget, why not record the voice yourself? Unfortunately to record your voice from home may be tricky. If you live in the countryside you will maybe hear the sound of a roster when you start to record your audio. 


ARTIFICIAL INTELLIGENCE: THE NEXT FRONTIER

With a computer-generated voice you are afraid to get a robotic, boring voice. However nowadays the AI-generated voices are getting really close to the best natural voices, for an unbeatable price. And this is going to save you a lot time.

After the voice, the next step are the subtitles. It’s important to have subtitles. Many people watch videos in noisy places like a public transport. In silent places, some people are muting the sound to do not disturb others. In both case it’s a good thing to help them to understand the videos with subtitles.

If someone is not a native speaker, subtitles are useful for a good understanding.

Subtitles are a lot of work. The subtitles can be generated with a Speech to Text software, but as you have probably noticed on YouTube, the automatic captions are a source of error.

If you use an AI-generated voice-over, with the voice generated from an input text, you always get the exact subtitle. There is no room for inaccuracy.


A SIMPLE, ALL-IN-ONE SOLUTION

Do you need a powerful and expensive computer to create a video with an AI-generated voice-over, auto-generated subtitles and many other features?

You just need to use Rollideo, it can work on any device, even a smartphone.

On top of that, Rollideo is specially designed to be super easy to use, because so many video editing software are very complicated to learn, and this is very time consuming.

Time is money, as the saying goes.

Now you can create videos with a single click.

        </div>
      </div>
    </div>

    <footer class="footer">
        <nav class="level">
                
          <div class="level-item has-text-centered">
            <div>
              <a v-bind:href="apiUrl + '/terms'">Terms of service</a> 
            </div>
          </div>

          <div class="level-item has-text-centered">
              <a v-bind:href="apiUrl + '/contact'">Contact</a> 
          </div>

        </nav>  
    </footer>


  </div>    
</template>

<script>
import axios from 'axios'
export default {
    data () {
            return {
              apiUrl : ''
            }
    }, 
    created () {
      this.apiUrl = process.env.API_URL;
    } 
  }
</script>

<style scoped>
.pre-formatted {
  white-space: pre-wrap;
}
 </style>



// WEBPACK FOOTER //
// src/components/About.vue